module.exports = __webpack_public_path__ + "img/footer.e8a4592a.png";